'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// general
var ROOT = exports.ROOT = 'mdc-dialog';
var OPEN = exports.OPEN = ROOT + '--open';
var BACKDROP = exports.BACKDROP = ROOT + '__backdrop';
var SURFACE = exports.SURFACE = ROOT + '__surface';

// header
var HEADER = exports.HEADER = ROOT + '__header';
var HEADER_TITLE = exports.HEADER_TITLE = HEADER + '__title';

// body
var BODY = exports.BODY = ROOT + '__body';
var SCROLLABLE = exports.SCROLLABLE = BODY + '--scrollable';
var SCROLL_LOCK = exports.SCROLL_LOCK = ROOT + '-scroll-lock';

// footer
var FOOTER = exports.FOOTER = ROOT + '__footer';
var FOOTER_BUTTON = exports.FOOTER_BUTTON = FOOTER + '__button';
var FOOTER_BUTTON_CANCEL = exports.FOOTER_BUTTON_CANCEL = FOOTER_BUTTON + '__cancel';
var FOOTER_BUTTON_ACCEPT = exports.FOOTER_BUTTON_ACCEPT = FOOTER_BUTTON + '__accept';


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Dialog/constants.js
// module id = 35
// module chunks = 0